class OrderInformationService {
    constructor(settings) {
        this.settings = settings;
        this.methodList = {
            unknown: '',
            pickup: 'pickup',
            delivery: 'delivery',
            express: 'express',
        };
    }

    getDeliveryMethod(method) {
        // unify order delivery method because Order Confirmation and TMO are returning different values.
        switch (method) {
            case 'Delivery':
            case 'Courier':
                return this.methodList.delivery;
            case 'XpressD':
            case 'Express':
                return this.methodList.express;
            case 'Pickup':
            case 'Hubspok':
                return this.methodList.pickup;
            default:
                return this.methodList.unknown;
        }
    }

    getWarningMessage({ order, deliveryMethod }) {
        if (!order) return '';

        const orderMethod = this.getDeliveryMethod(deliveryMethod);

        // check restricted products first as it takes precedence.
        if (order.ContainsRestrictedBySignatureAndPhotoId) {
            return orderMethod === this.methodList.pickup
                ? this.settings.delivery.restrictionWarningPickupSignatureAndPhotoId
                : this.settings.delivery.restrictionWarningDeliverySignatureAndPhotoId;
        } else if (order.ContainsRestrictedBySignature) {
            return orderMethod === this.methodList.pickup
                ? this.settings.delivery.restrictionWarningPickupSignature
                : this.settings.delivery.restrictionWarningDeliverySignature;
        } else if (order.ContainsFrozen
            && orderMethod === this.methodList.delivery
            && order.CanLeaveOrderUnattended) {
            return this.settings.delivery.frozenDeliveryWarning;
        }

        return '';
    }
}

OrderInformationService.$inject = ['Settings'];

module.exports = OrderInformationService;



// WEBPACK FOOTER //
// ./src/shop/orderinformation/order-information.service.js